import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74915cab"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增配置")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "是否启用：", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "终端：", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_8 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"min-width":"50px"} }, "搜索：", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_11 = {
  key: 1,
  class: "breaks"
}
const _hoisted_12 = { key: 4 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "页面配置列表",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.goSet
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_row, { align: "middle" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_a_select, {
                  value: _ctx.searches.status,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.status) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearch('status', $event, $event))),
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "0" }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_divider, { type: "vertical" }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_a_select, {
                  value: _ctx.searches.terminal,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searches.terminal) = $event)),
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSearch('terminal', $event, $event))),
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dictionaryTerminal, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item.id,
                        key: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_divider, { type: "vertical" }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_a_input_search, {
                    value: _ctx.searches.name,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searches.name) = $event)),
                    "enter-button": "",
                    onSearch: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSearch('name', $event, $event))),
                    placeholder: "输入名称搜索"
                  }, null, 8, ["value"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { style: {"flex":"1"} }),
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "dashed",
                  onClick: _ctx.resetSearch
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'link_type')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.linkTypesArr[text]), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'link')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(text) + _toDisplayString(_ctx.renderParams(record.params)), 1))
          : _createCommentVNode("", true),
        (column.key === 'terminal')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(text === 1 ? '移动端' : 'PC端'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'status')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(record.status === 1 ? '是' : '否'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_a_button, {
                size: "small",
                danger: record.status === 0,
                onClick: ($event: any) => (_ctx.onSetStatus(record.id, record.status)),
                style: {"margin":"5px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(record.status === 0 ? '启用' : '禁用'), 1)
                ]),
                _: 2
              }, 1032, ["danger", "onClick"]),
              _createVNode(_component_a_button, {
                size: "small",
                onClick: ($event: any) => (_ctx.goSet(record)),
                style: {"margin":"5px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_a_popconfirm, {
                title: "是否删除该条信息?",
                onConfirm: ($event: any) => (_ctx.onDel(record.id))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
  ], 64))
}